module.exports = __webpack_public_path__ + "assets/b3d063587b26fd8fc2e87037cbccd3fb.svg";